// extracted by mini-css-extract-plugin
module.exports = {"comp":"UserListA_comp__YdyOl"};